<template>
  <div class="kpi_record" @click="openRecordModal">
    <template v-if="record.property.line_1 || record.property.city || record.property.state">
      <h4 class="kpi_record--address">
        {{ record.property.line_1 }}

        {{ record.property.city }}<template v-if="record.property.city && record.property.state">,</template>
        {{ record.property.state }}
      </h4>

    </template>

    <template v-else>
      <h4 class="kpi_record--address">Unknown Address</h4>
    </template>

    <p class="kpi_record--contact">{{ fullName }}</p>
    <p class="kpi_record--created">Created on {{ createdDate }} by {{ record.createdBy.display_name }}</p>
  </div>
</template>

<script>
import dates from "../../../services/dates";
import router from "../../../router";

export default {
  props: {
    record: {
      type: Object,
      required: true
    },
  },
  computed: {
    fullName() {
      if (!this.record.contact) {
        return;
      }

      const first = this.record.contact.first_name ? this.record.contact.first_name : '';
      const last = this.record.contact.last_name ? this.record.contact.last_name : '';
      const name = `${first} ${last}`;

      return name === ' ' ? 'Unknown Contact' : name;
    },
    createdDate() {
      return dates.formatAsDateTime(this.record.created_at);
    }
  },
  methods: {
    openRecordModal() {
      this.$emit('close');
      router.replace({query: {lead: this.record.id}});
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.kpi_record {
  display: block;
  padding: 6px;
  border-bottom: 1px solid $border;
  cursor: pointer;

  &:hover {
    background: $grey-50;

    .kpi_record--address {
      color: $link-hover;
    }
  }

  &--address {
    margin-bottom: 8px;
    color: $link;
  }

  &--contact {
    margin: -4px 0 8px;
  }

  &--created {
    font-size: 0.875rem;
  }
}
</style>
